<template>
  <q-btn-dropdown
    v-if="pendingReconnections > 0"
    icon="fa fa-clock"
    :label="pendingReconnections"
    color="warning"
    rounded
  >
    <div class="q-pa-md">
      <message type="warning">
        {{ pendingReconnections }}
        social account<span v-show="pendingReconnections > 1">s</span>
        are pending client action.
      </message>
    </div>
    <div class="text-center q-mb-md">
      <q-btn
        label="View Social Accounts"
        :to="`/social/customers/${this.accountId}/accounts/pending-reconnection`"
        color="primary"
      />
    </div>
  </q-btn-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import { AccountStats } from '@/type';
import statsService from '@/stats/stats-service';
import Message from '@/components/message/Message.vue';
import eventBus from '@/messaging/event-bus';
import {
  ReconnectRequestCreated,
  ReconnectRequestCanceled,
} from '@/social/account/action/reconnect';

interface Data {
  pendingReconnections: number,
  timerId: number|null,
  task: Promise<AccountStats>|null,
}

export default defineComponent({
  mixins: [HasTaskMixin],
  components: { Message },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      pendingReconnections: 0,
      timerId: null,
      task: null,
    };
  },
  watch: {
    accountId: {
      handler() {
        this.poll();
      },
      immediate: true,
    },
  },
  methods: {
    load(): Promise<AccountStats> {
      this.task = statsService.findAccountStats(this.accountId);
      this.task.then((stats) => {
        this.pendingReconnections = stats.pendingReconnections;
      });
      return this.task;
    },
    poll() {
      this.load().then(() => {
        setTimeout(this.poll, 10000);
      });
    },
    onRequestCreated(): void {
      this.pendingReconnections += 1;
    },
    onRequestCanceled(): void {
      this.pendingReconnections -= 1;
    },
  },
  created(): void {
    eventBus.$on(ReconnectRequestCreated.eventName, this.onRequestCreated);
    eventBus.$on(ReconnectRequestCanceled.eventName, this.onRequestCanceled);
  },
  beforeUnmount(): void {
    eventBus.$off(ReconnectRequestCreated.eventName, this.onRequestCreated);
    eventBus.$off(ReconnectRequestCanceled.eventName, this.onRequestCanceled);
  },
});
</script>
